<script>
import store from "@/state/store"; 
import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import RiskBirimleri from "./RiskBirimleri.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import moment from "moment";
import AddEdit from "./StrRisk/AddEdit.vue";
import AddEdit2 from "./StrRiskBirim/AddEdit.vue";
import AddEdit3 from "./StrRiskGiris/AddEdit.vue";
import StrRisk from "@/models/StrRisk";
import StrRiskGiris from "@/models/StrRiskGiris";
import StrRiskBirim from "@/models/StrRiskBirim";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
//import { filter } from 'vue/types/umd';
export default {
  mixins: [Api, Sabit, StrRisk, StrRiskBirim, StrRiskGiris],
  page: {
    title: "Riskler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    RiskBirimleri,
    AddEdit,
    AddEdit2,
    AddEdit3,
    formcombobox,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrRiskler.Title"),
      items: [
        {
          text: this.$t("StrRiskler.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrRiskler.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrRiskler.Title"),
          active: true,
        },
      ],
      FilitrelemePenceresi: true,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Filter: {
        DonemId: "",
        AltDonemId: "",
        AmacId: "",
        Risktipi:"",
        BirimId: null,
      },
      DonemIdComboBox: [],
      AltDonemIdComboBox: [],
      AmacIdComboBox: [],
      StrRiskDeger: [],
      KullaniciBilgileri: null,
      TableData: {},
      sayac:0,
      sira_num:0,
      DataUpdate: "",
      AddEdit: "",
      AltDonem: "",
      Riskid: "",
      guncelle: 0,
      siralama:"&Asc=Risk",
    };
  },
  validations: {
    Filter: {
      DonemId: { required },
      AltDonemId: {},
      AmacId: {},
      Risktipi:{required},
      BirimId: {}
    },
  },
  methods: {
    Get() {},
    FilterGet() {
      this.guncelle=0;
      this.$v.$touch();
      if (!this.$v.$invalid) {

        let Filter = "&Asc=SiraNo"; 

        if (this.Filter.Risktipi!=null && this.Filter.Risktipi!="") Filter=Filter+ "&Risktipi=" + this.Filter.Risktipi;
        if (this.Filter.DonemId!=null && this.Filter.DonemId!="") Filter=Filter+ "&DonemId=" + this.Filter.DonemId;
        if (this.Filter.AmacId!=null && this.Filter.AmacId!="") Filter=Filter+ "&AmacId=" + this.Filter.AmacId;
        if (this.Filter.BirimId!=null && this.Filter.BirimId!="") Filter=Filter + "&BirimId=" + this.Filter.BirimId;

        if(this.yetki_kontrol('SuperAdmin')<0  && this.yetki_kontrol('StrAdmin')<0) {
             Filter=Filter+"&YetkiliBirimGetir=true";
        }


      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

        this.ActionsFilterGet({ Service: "StrRisk", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
          this.sira_num=res.Data[res.TotalCount-1].SiraNo+1;

          this.guncelle=1;
        });

     
      }
    },
    yetki_kontrol(yetki){

        var sonuc = this.KullaniciBilgileri.indexOf(yetki);
        return sonuc; 

    },

    DonemSec() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.AltDonemIdComboBox = [];
      let Filter = "&UstId=" + this.Filter.DonemId + "&Approval=true";
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.AltDonemIdComboBox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Aciklama,
            YilBas: res.Data[i].YilBas,
            Aciklama: res.Data[i].Aciklama,
            RiskDegerBaslamaTarihi: res.Data[i].RiskDegerBaslamaTarihi,
            RiskDegerBitisTarihi: res.Data[i].RiskDegerBitisTarihi,
          });
        }
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    RiskDegerFilter(RiskId, Donemid) {
      let Filter = this.StrRiskDeger.filter((notification) => notification.Riskid.includes(RiskId));

      Filter = Filter.filter((notification) => notification.Donemid.includes(Donemid));
     
      let VeriUzunlugu = Filter.length;

      if (VeriUzunlugu > 0) {
  
        return Filter[0].Riskpuani;
      } else {
        return;
      }
    },
    RiskBirimAddEdit(Islem, Riskid) {
      if (Islem == "Add") {
        let Filter = "&Riskid=" + Riskid;
        this.ActionsFilterGet({
          Service: "StrRiskBirim",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          if (res.TotalCount != 0) {
            this.AddEdit = "Edit";
            this.DataUpdate = res.Data[0];
            this.$bvModal.show("StrRiskBirim");
          } else {
            this.AddEdit = "Add";
            const Bellek = this.StrRiskBirimData;
            this.DataUpdate = Bellek;
            this.Riskid = Riskid;
            this.$bvModal.show("StrRiskBirim");
          }
        });
      } else {
        this.AddEdit = "Edit";
        this.DataUpdate = Riskid;
        this.$bvModal.show("StrRiskBirim");
      }
    },

    amac_yukle(DonemId){

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      this.AmacIdComboBox=[];

      if(DonemId!=null && DonemId!=""){

          let Filter="&DonemId="+DonemId;

          this.ActionsFilterGet({ Service: "StrStratejikAmac", Page: Page, Filter:Filter }).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                this.AmacIdComboBox.push({
                  Id: res.Data[i].Id,
                  Value: res.Data[i].Aciklama,
                });
              }
          });

      }

  }

  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.KullaniciBilgileri = store.getters["auth/UserRolles"];

    this.ActionsGet({ Service: "StrRiskDeger", Page: Page }).then((res) => {
      this.StrRiskDeger = res.Data;
    });


    let sorgu = "&Tip=1561";
    let Tip=[];
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
   
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==5) { 

                  Tip.push(res.Data[i].Id);       

              } 
             
          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;


    this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu}).then((res) => {
      let Tarih = moment(new Date()).format("YYYY-MM-DD");
      for (var i = 0; i < res.Data.length; i++) {
        if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
          this.DonemIdComboBox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Aciklama,
          });
        }
      }
    });

  });
  },
  
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-4"></div>
              <div class="col-sm-8">
                <div class="text-sm-end">

                  <b-dropdown variant="success" class="btn  btn-rounded mb-2 me-2">
                    <template v-slot:button-content> <i class="mdi mdi-file-export-outline me-1"></i> 
                      {{ $t("StrRiskler.Page.ExceleAktar") }} <i class="mdi mdi-chevron-down"></i> 
                    </template>
                    <b-dropdown-item href="javascript: void(0);">{{ $t("StrRiskler.Page.RiskRaporu") }}</b-dropdown-item>
                  </b-dropdown>
                  
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer">
                    <i class="mdi mdi-text-search me-1"></i>
                    {{ this.$t("StrRiskler.Page.Filtreleme") }}
                  </button>
                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrRisk @click="(DataUpdate = StrRiskData), (AddEdit = 'Add')">
                    <i class="mdi mdi-plus me-1"></i>
                    {{ this.$t("StrRiskler.Page.YeniKayitEkle") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered mb-0" v-if="TableData.length">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Sira No</th>
                    <th scope="col">
                      {{ $t("StrRiskler.Table.Risk") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Risk'" @click="siralama='&Asc=Risk', FilterGet()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Risk'" @click="siralama='&Desc=Risk', FilterGet()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col">
                      {{ $t("StrRiskler.Table.AmacAciklama") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=AmacAciklama'" @click="siralama='&Asc=AmacAciklama', FilterGet()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=AmacAciklama'" @click="siralama='&Desc=AmacAciklama', FilterGet()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col">
                      {{ $t("StrRiskler.Table.Hedef") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Hedef'" @click="siralama='&Asc=Hedef', FilterGet()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Hedef'" @click="siralama='&Desc=Hedef', FilterGet()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col" v-for="AltDonemVerileri in AltDonemIdComboBox" :key="AltDonemVerileri.Id">
                      {{ AltDonemVerileri.Aciklama }}
                      {{ $t("StrRiskler.Table.RiskPuani") }}
                    </th>
                    <th scope="col">
                      {{ $t("StrRiskler.Table.Aciklama") }}
                    </th>
                    <th scope="col" style="width: 85px; text-align: center; vertical-align: middle;">
                      {{ $t("StrRiskler.Table.Islem") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
                  <tr>
                    <th scope="row" class="custom-accordion">
                      <a
                        class="
                          text-body
                          fw-medium
                          py-1
                          d-flex
                          align-items-center
                        "
                        data-toggle="collapse"
                        v-b-toggle="'CollapseAltTablo' + TableDataVerileri.Id"
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                      >
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                    <td>{{ TableDataVerileri.SiraNo }}</td>
                    <td>{{ TableDataVerileri.Risk }}</td>
                    <td>{{ TableDataVerileri.AmacAciklama }}</td>
                    <td>{{ TableDataVerileri.Hedef }}</td>
                    <td v-for="AltDonemVerileri in AltDonemIdComboBox" :key="AltDonemVerileri.Id">

        
                      <span v-if="RiskDegerFilter(TableDataVerileri.Id, AltDonemVerileri.Id) && TableDataVerileri.Risktipi==1 &&
                      ( yetki_kontrol('StrRiskDegerlendirmeIslemleri')>=0 
                        || yetki_kontrol('StrAdmin')>=0  || yetki_kontrol('SuperAdmin')>=0)" 
                      v-b-modal.StrRiskGiris @click="(DataUpdate = TableDataVerileri), (AddEdit = 'Edit'), 
                      (AltDonem = AltDonemVerileri.Id),(sayac=sayac+1)">
                        <b-button class="mx-2" variant="outline-info"><i class="bx bx-cog bx-spin"></i> 
                          {{ $t("StrRiskler.Table.DegerlendirButton") }}
                        </b-button>
                      </span>

                    </td>
                    <td>{{ TableDataVerileri.Aciklama }}</td>
                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                      <b-button-group>
                        <b-button variant="success" @click="RiskBirimAddEdit('Add', TableDataVerileri.Id)"><i class="fas fa-plus"></i></b-button>
                        <b-button variant="primary" v-b-modal.StrRisk @click="(DataUpdate = TableDataVerileri), (AddEdit = 'Edit')"><i class="fa fa-pencil-alt"></i></b-button>
                        <b-button variant="danger" @click="Delete('StrRisk', TableDataVerileri.Id)"><i class="fa fa-trash-alt"></i></b-button>
                      </b-button-group>
                      
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7">
                      <b-collapse class="collapse show" :id="'CollapseAltTablo' + TableDataVerileri.Id">

                          <RiskBirimleri :RiskId="TableDataVerileri.Id" :Guncelle="guncelle" @Id="RiskBirimAddEdit('Edit', $event)" />

                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>



      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit"  :Risk="Filter.Risktipi" :sira_num="sira_num" @TableUpdate="FilterGet()"/>
      <AddEdit2 :Id="DataUpdate" :AddEdit="AddEdit" :Riskid="Riskid" @TableUpdate="FilterGet()"/>
      <AddEdit3 :Id="DataUpdate" :AddEdit="AddEdit" :AltDonem="AltDonem" :Sayac="sayac" @TableUpdate="FilterGet()"/>

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrRiskler.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrRiskler.Filtreleme.Content") }}
            <br>
            <br>
            
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Risktipi',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskler.Filtreleme.Risktipi'),
                  ComboDataArray: FormDataType.Risktipi.ComboDataArray,
                }"
                :Value="Filter.Risktipi"
                :v="$v.Filter.Risktipi"
                @input="(Filter.Risktipi = $event)"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'DonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskler.Filtreleme.UstDonemId'),
                  ComboDataArray: DonemIdComboBox,
                }"
                :Value="Filter.DonemId"
                :v="$v.Filter.DonemId"
                @input="(Filter.DonemId = $event),DonemSec(),amac_yukle($event)"
              />
            </div>

           
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'AmacId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskler.Filtreleme.AmacId'),
                  ComboDataArray: AmacIdComboBox,
                }"
                :Value="Filter.AmacId"
                :v="$v.Filter.AmacId"
                @input="Filter.AmacId = $event"
              />
            </div>

            <div class="mb-3">

                <b-form-group
                    class="mb-2"
                    id="birimler"
                    :label= "$t('StrRiskler.Filtreleme.BirimId')"
                    label-for="text"
                  >
                    <BirimSecimi
                      :title_position="'mb-3'"
                      :selected="Filter.BirimId"
                      :labels_lg="'3'"  
                      :multiple="false"
                      :YetkiKontrol="1"
                      :BirimTipId="null"
                      @Secilmis_Idler="Filter.BirimId=$event"
                    />
                </b-form-group>

            </div>

            <b-button @click="FilterGet(), rightDrawer()" class="btn btn-primary" variant="primary"> {{ $t("StrRiskler.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
